import { Button, ButtonGroup } from "@blueprintjs/core";
import { format } from "date-fns";
import * as React from "react";
import styled from "styled-components";

import { useCalendarContext } from "../CalendarContext";
import { ECalendarTlCode } from "../ECalendarTlCode";

export interface NavigatorProps {}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TitleSection = styled.div`
  font-size: large;
  font-weight: bolder;
  align-self: center;
`;

const RightSection = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;
  & > * + * {
    margin-left: 0.5rem;
  }
`;

export const Navigator: React.FunctionComponent<NavigatorProps> = (props) => {
  const {
    viewMode,
    days,
    navigateInDays,
    dateFNSLocale,
    translateFn,
    currentDate,
  } = useCalendarContext();

  const formattedTitle = React.useMemo(() => {
    if (viewMode === "week") {
      const formatFn = (date: Date) =>
        format(date, "PPP", { locale: dateFNSLocale });

      const firstDay = days[0];
      const lastDay = [...days].reverse()[0];

      return `${formatFn(firstDay.date)} - ${formatFn(lastDay.date)}`;
    }
  }, [dateFNSLocale, days, viewMode]);

  const [daysToToday, setdaysToToday] = React.useState(0);

  return (
    <Container>
      <TitleSection>
        {formattedTitle}{" "}
        <Button
          text={translateFn(ECalendarTlCode.Today)}
          onClick={() => {
            setdaysToToday(0);
            navigateInDays(daysToToday);
          }}
        />
      </TitleSection>
      <RightSection>
        {/* <ViewModeButton /> */}

        <ButtonGroup>
          <Button
            icon="double-chevron-left"
            onClick={() => {
              setdaysToToday(daysToToday + 7);
              navigateInDays(-7);
            }}
          />
          <Button
            rightIcon="double-chevron-right"
            onClick={() => {
              setdaysToToday(daysToToday - 7);
              navigateInDays(7);
            }}
          />
        </ButtonGroup>
      </RightSection>
    </Container>
  );
};
